import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchYoutubeLinksData = (token, page) => async (dispatch) => {
  dispatch({ type: "FETCH_YOUTUBE_LINKS_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getAllYoutubeLinks?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "FETCH_YOUTUBE_LINKS_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_YOUTUBE_LINKS_FAILURE",
      payload: error.message,
    });
  }
};
